var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementEarned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.834,
    height: 49,
    viewBox: "0 0 36.834 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Band",
    transform: "translate(-7.95 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15669",
    "data-name": "Path 15669",
    d: "M32.059,35.142c1.746-.567,2.381-3.338,3.836-4.4,1.47-1.064,4.3-.819,5.375-2.289,1.057-1.455-.046-4.065.521-5.819.551-1.684,2.994-3.139,2.994-5.007s-2.442-3.33-2.994-5.015c-.567-1.746.536-4.364-.521-5.811-1.072-1.47-3.9-1.233-5.375-2.3C34.448,3.445,33.8.666,32.059.1c-1.684-.544-3.82,1.309-5.689,1.309S22.359-.444,20.675.1c-1.746.567-2.381,3.346-3.836,4.4-1.47,1.064-4.3.827-5.375,2.289-1.057,1.455.046,4.073-.521,5.819-.551,1.684-2.994,3.147-2.994,5.015s2.442,3.323,2.994,5.007c.567,1.753-.536,4.364.521,5.819,1.072,1.462,3.9,1.225,5.375,2.289,1.447,1.064,2.09,3.836,3.836,4.4,1.684.544,3.82-1.3,5.7-1.3C28.231,33.84,30.375,35.685,32.059,35.142Zm-5.7-6.592A10.925,10.925,0,1,1,37.281,17.624,10.926,10.926,0,0,1,26.363,28.55Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15670",
    "data-name": "Path 15670",
    d: "M42.562,40.986A6.541,6.541,0,0,0,41.23,42.74a5.659,5.659,0,0,1-2.756,2.779,3,3,0,0,1-.949.145,7.614,7.614,0,0,1-2.81-.758c-.2-.084-.406-.161-.6-.237L37.065,58.5l5.076-5.949L49.4,53.711,43.519,40.55a3.482,3.482,0,0,0-.957.436Z",
    transform: "translate(-6.131 -9.504)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15671",
    "data-name": "Path 15671",
    d: "M21.795,45.664a3,3,0,0,1-.949-.145,5.69,5.69,0,0,1-2.764-2.787,6.49,6.49,0,0,0-1.332-1.746,3.648,3.648,0,0,0-.949-.436L9.92,53.711l7.258-1.156L22.246,58.5l2.963-13.835c-.207.077-.406.153-.612.237a7.5,7.5,0,0,1-2.8.758Z",
    transform: "translate(-0.462 -9.504)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15672",
    "data-name": "Path 15672",
    d: "M37.493,17.9l-5.467-.8-2.45-4.961L27.127,17.1l-5.467.8,3.958,3.859-.934,5.451,4.892-2.58,4.892,2.58-.934-5.451Z",
    transform: "translate(-3.213 -2.845)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementEarned);
export default __webpack_public_path__ + "static/media/achievement_earned.7ea2f15b8a9ad309881819fdef2ceb69.svg";
export { ForwardRef as ReactComponent };